import { MediaLimitsIndicationView } from '@app/modules/social-export/lib/format-media-limits-indication';
import { Box, Tooltip } from '@mui/material';
import { ReactNode } from 'react';
import { MediaLimitsIcon } from './MediaLimitsIcon';

type MediaLimitsShortProps = {
  indication: MediaLimitsIndicationView;
  /** When provided, wraps this content with a tooltip; otherwise renders icon+tooltip only. */
  children?: ReactNode;
  placement?: 'left' | 'right' | 'top' | 'bottom';
};

/**
 * Short media-limits display: warning/info icon with tooltip, optionally wrapping a control.
 */
export function MediaLimitsShort({
  indication,
  children,
  placement = 'right',
}: MediaLimitsShortProps) {
  const icon = <MediaLimitsIcon kind={indication.kind} />;

  if (!children) {
    return (
      <Tooltip title={indication.message} placement={placement}>
        <Box component="span" sx={{ display: 'inline-flex', alignItems: 'center' }}>
          {icon}
        </Box>
      </Tooltip>
    );
  }

  return (
    <Tooltip title={indication.message} placement={placement}>
      <Box component="span" sx={{ display: 'block' }}>
        {children}
      </Box>
    </Tooltip>
  );
}
